<template>
  <div>
  <van-cell title="合同名称"  :label="ht.htmz" />
     <van-cell title="合同编号"  :value="ht.htbh" />
     <van-cell title="合同金额" :value="ht.htje"  />
     <van-cell v-if="true" title="所属部门" :value="U.chooseValueFromArr(depts,'deptId',ht.deptid, 'deptName')"  />
      <van-cell v-if="true" title="委托单位" :value="U.chooseValueFromArr(dict.type.xm_wtdw,'dictValue',ht.wtdw,'dictLabel')"  />
       <van-cell v-if="ht.kuInfo" title="供应商"  :label="ht.kuInfo.mc" />
      <van-cell v-if="true" title="合同类型" :value="U.chooseValueFromArr(dict.type.xm_xsht_lx,'dictValue',ht.htlx,'dictLabel')"  />
     <van-cell v-if="true" title="项目负责人" :value="ht.fzr"  />
      <van-cell v-if="true" title="采购分包" :value="ht.cgfb"  />
     <van-cell v-if="true" title="采购方式" :value="ht.cgfs"  />

     <van-cell v-if="true" title="签订日期" :value="U.parseTime(ht.qdrq,'{y}-{m}-{d}')"  />

     <van-cell v-if="true" title="是否招标" :value="U.chooseValueFromArr(dict.type.xm_yes_no,'dictValue',ht.sftb,'dictLabel')"  />


    <van-cell v-if="ht.htwj" title="合同文件"  >
         <template #label>
           <Filedownload :srcs="ht.htwj"></Filedownload>
         </template>
     </van-cell>

  <van-cell v-if="ht.ewsx" title="合同额外属性">
    <template #label>
      <span :key="item" v-for="item in ht.ewsx.split(',')" style="margin: 1rem;">{{U.chooseValueFromArr(dict.type.xm_htfjsx,'dictValue',item,'dictLabel')}}</span>
    </template>
    </van-cell>
      <van-divider>具体采购项目</van-divider>
    <van-cell v-if="ht.products" :key="item.pid" v-for="item in ht.products" :title="U.chooseValueFromArr(products,'id',item.pid,'mz')">
      <template #label>
        <span  style="margin: 1rem;">数量:{{item.nums}}</span>
       <span  style="margin: 1rem;">单价:{{item.danjia}}</span>
       <span  style="margin: 1rem;">总价:{{item.zje}}</span>
      </template>
    </van-cell>
    </div>
</template>

<script>
  import Filedownload from '../../components/FileDownload/index.vue'

export default {
  name: 'cght',
  components: {
    Filedownload: Filedownload
  },
  props: {
      htid: {
        type: String,
        default: null,
      },
      ht:{
        type:Object,
        default:null
      }
    },
  data () {
    return {

      dict: {type: []},
      dicts: ['xm_htjd', 'xm_hzxz', 'xm_yes_no', 'xm_htfjsx','xm_wtdw','xm_xsht_lx'],
      dataid: null,
      workid: null,
      dqlc:null,
      products:[],
      depts: [],
      shshow: false,
      loading: false,
      form: {
        dataid: null,
        shzt: 1,
        shyj: ''
      }

    }
  },
  created () {
    //  console.log("this",this.$route.query)

    this.getdepts()
    this.getdicts()
    this.getHt()
    this.getProducts()
  },
  methods: {


    getdepts () {
      let that = this
      this.$ajax.get('/system/dept/list').then(res => {
        that.depts = res.data
      })
    },
    getProducts () {
      let that = this
      this.$ajax.get('/xm/product/kylist').then(res => {
        that.products = res.data
      })
    },
    getdicts () {
      let that = this
      if (this.dicts.length > 0) {
        for (let d of this.dicts) {
          // console.log("d",d)
          this.$ajax.get('/system/dict/data/type/' + d).then(res => {
            that.dict.type[d] = res.data
            //  console.log(that.dict)
          })
        }
      }
    },
    getHt () {
      let that = this
      if(this.ht)return;
      else
      this.$ajax.get('/xm/cght/' + this.htid).then(function (res) {
        if (res.code == 200) {
          that.ht = res.data
          console.log('that.ht', res.data)
        }
      })
    },



  }
}


</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/Zsmb/cght.vue